import React from "react";
import { Breadcrumb } from "semantic-ui-react";
import { observer } from "mobx-react-lite";

interface IProps {
  sections: any[];
  title: string;
}

const BreadcrumbContainer: React.FC<IProps> = ({ title, sections }) => {
  return (
    <div className="breadcrumb">
      <h3>{title}</h3>
      <Breadcrumb key={title}>
        {sections.map((section, i) => (
          <div className="breadcrumSection" key={`${title}-${i}`}>
            <Breadcrumb.Section content={section.content} />
            <Breadcrumb.Divider icon="angle double right" />
          </div>
        ))}
      </Breadcrumb>
    </div>
  );
};

export default observer(BreadcrumbContainer);
